module.exports = __webpack_public_path__ + "img/cave84.3af48fc9.jpg";